import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, AbstractControl, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms'; 
import { department, division, user } from './../../../models/admin';
import { AdminApiService } from './../../../services/admin.service';
import { UtilityService } from './../../../services/utility.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { element } from 'protractor';
import Swal from 'sweetalert2';
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
import { kpitarget } from '../../../models/slakpi';
import { SLAKPIApiService } from '../../../services/slakpi.service';
 


@Component({
  selector: 'app-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.css']
})
export class DivisionComponent implements OnInit {
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  searchText: string;
  dataSearch: any;
  modalRef: BsModalRef;
  @ViewChild('editSettingsTemplate', { static: false }) editTemplate: TemplateRef<any>;

  headerTitle: string;
  @ViewChild('targetTemplate', { static: false }) targetTemplate: TemplateRef<any>;
  public defaultyear: number = 0;
  public selected_kpiUno: number = 0;
  public kpiTargetForm: FormGroup;
  public yearsArray: FormArray;
  public selected_schedule: number = 1;
  public submitClicked: boolean = false;

  public title: string = 'Add Role';
  public data: any;
  public division_data: any;
  public user_data: any;
  public editSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public filterSettings: Object;
  public orderData: object;
  public divisionData: object[];
  public divisionForm: FormGroup;
  
  public pageAction: string = 'add';
 
  public permission: number = 1;

  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  isEditOnly: boolean = false;
    
    

  constructor(private formTargetBuilder: FormBuilder,public restApi: AdminApiService, public restSLAKPIApi: SLAKPIApiService, public utilityService: UtilityService, private router: Router, private toaster: ToasterService,private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.defaultyear = this.user.currentYear;

    this.isEditOnly = (this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'BM Administrator') ? true : false;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin && !this.isEditOnly) {
      this.router.navigateByUrl('/access-denied');
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };

    this.loadDivision();    
    this.getUsers();
    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
    
    if (this.permission == 1) {
      this.toolbar = ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    else
      this.toolbar = ['Search', 'ExcelExport'];
    
    this.pageSettings = { pageCount: 5 };
    this.filterSettings = { type: 'Excel' };
   // this.divisionData = DataUtil.distinct(this.data, 'id', true);

    
  }

  // Get division list
  loadDivision() {
    this.spinner.show();
    let inpValue = new division();    
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 4;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.data = data;
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            divisionCode: this.data[i].divisionCode,
            divisionNameEn: this.data[i].divisionNameEn,
            divisionNameAr: this.data[i].divisionNameAr,
            approverName: this.data[i].approverName,
            coordinatorName: this.data[i].coordinatorName,
            divisionAdminName: this.data[i].divisionAdminName,
            divisionUno: this.data[i].divisionUno,
            divisionHeadUno: this.data[i].divisionHeadUno,
            divisionCoordinatorUno: this.data[i].divisionCoordinatorUno,
            divisionAdminUno: this.data[i].divisionAdminUno,
            divisionApproverUno: this.data[i].divisionApproverUno,
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      }); 
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'divisionCode', name: 'Division Code', field: 'divisionCode', sortable: true, maxWidth: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionCode', 'divisionCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'divisionNameEn', name: 'Division Name [English]', field: 'divisionNameEn', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionNameEn', 'divisionNameEn'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'divisionNameAr', name: 'Division Name [Arabic]', field: 'divisionNameAr', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionNameAr', 'divisionNameAr'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'approverName', name: 'Approver', field: 'approverName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'approverName', 'approverName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'coordinatorName', name: 'Coordinator', field: 'coordinatorName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'coordinatorName', 'coordinatorName'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', maxWidth: 75,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'edit_row', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-edit fa-lg', cssClass: 'green-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1 && this.isAdmin)
                  return true;
                else false;
              },
              action: (e, args) => {
                this.editItem(args.dataContext);
              }
            },
            {
              command: 'target-row', titleKey: 'Target_ROW', positionOrder: 63, title: 'Target',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isAdmin ||this.editItem)
                  return true;
                else return false;
              },
              iconCssClass: 'fa fa-bullseye', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';

                
                if (this.permission == 1) {
                  this.submitClicked = false;
                  let objdata: any = args.dataContext;
                  this.createTargetFormGroup(objdata);
                  this.headerTitle = 'Details of ' + objdata.divisionNameEn + " | " + 'Quarterly';
                  this.selected_schedule = 3;//objdata.scheduleUno;
                  this.selected_kpiUno = objdata.divisionUno;//objdata.kpiUno == null || objdata.kpiUno == '' ? objdata.strKPIUno.replace('k_', '') : objdata.kpiUno;
                  this.addTargetItem(this.selected_kpiUno, this.selected_schedule);
                  this.modalRef = this.modalService.show(
                    this.targetTemplate,
                    Object.assign({}, {
                      class: 'gray modal-xl modal-full',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'del_row', positionOrder: 65, title: 'Delete',
              iconCssClass: 'fa fa-trash fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1 && this.isAdmin)
                  return true;
                else false;
              },
              action: (e, args) => {
                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteDivision(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              }
            },


          ],
        }
      }

    ]


  }


  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (this.permission == 1 )
      return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
    else
      return '';
  };



  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  getUsers() {
    
    let inpValue = new user();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 4;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;     
        
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  createFormGroup(data1: any): FormGroup {
    
    return new FormGroup({
      divisionUno: new FormControl(data1.divisionUno),
      divisionNameEn: new FormControl(data1.divisionNameEn, Validators.required),
      divisionNameAr: new FormControl(data1.divisionNameAr, Validators.required),
      divisionCode: new FormControl(data1.divisionCode, Validators.required),
      divisionHeadUno: new FormControl(data1.divisionHeadUno.toString()),
      divisionAdminUno: new FormControl(data1.divisionAdminUno.toString()),
      divisionCoordinatorUno: new FormControl(data1.divisionCoordinatorUno.toString()),
      divisionApproverUno: new FormControl(data1.divisionApproverUno.toString()),
    });
  }
  addItem() {
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.pageAction = "add";
    this.submitClicked = false;

    this.title = 'Add Division';
    this.divisionForm = new FormGroup({
      divisionUno: new FormControl(0),
      divisionNameEn: new FormControl(null, Validators.required),
      divisionNameAr: new FormControl(null, Validators.required),
      divisionCode: new FormControl(null, Validators.required),
      divisionHeadUno: new FormControl(0),
      divisionAdminUno: new FormControl(0),
      divisionCoordinatorUno: new FormControl(0),
      divisionApproverUno: new FormControl(0),
    });
  }

  editItem(data) {
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.pageAction = "edit";
    this.submitClicked = false;
    this.title = 'Details of ' + data.divisionCode + ":" + data.divisionNameEn 
    this.divisionForm = this.createFormGroup(data)
  }
  saveDivision(): void {
    this.submitClicked = true;
    if (this.divisionForm.valid) {
      let data = this.divisionForm.value;
      this.AddEditDivision(data);
    }
    else {
     // Swal.fire('Error', 'Enter the required values', 'error')
      this.toaster.show('error', 'Error', 'Enter the required values.');
    }
  }
 

  AddEditDivision(data1: any) {
    if (this.divisionForm.invalid) {
     // Swal.fire('Error', 'Something went wrong!', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong!.');
      return false;
    }

 
    if (this.DuplicateNameCheck(this.utilityService.isStringNull(data1.divisionCode), this.utilityService.isNumericNull(data1.divisionUno))) {
     // Swal.fire('Error', 'Duplicate codes are not allowed', 'warning');
      this.toaster.show('warning', 'Warning', 'Duplicates are not allowed');
      return false;
    }
    else {

      
      let objDivision = new division();
      objDivision.actionType = this.pageAction;
      objDivision.divisionUno = (this.pageAction == "add") ? 0 : data1.divisionUno;
      objDivision.divisionNameEn = this.utilityService.isStringNull(data1.divisionNameEn);
      objDivision.divisionNameAr = this.utilityService.isStringNull(data1.divisionNameAr);
      objDivision.divisionCode = this.utilityService.isStringNull(data1.divisionCode);
      objDivision.divisionHeadUno = this.utilityService.isNumericNull(data1.divisionHeadUno);
      objDivision.divisionAdminUno = this.utilityService.isNumericNull(data1.divisionAdminUno);
      objDivision.kPILastAutoId = 0;
      objDivision.divisionCoordinatorUno = this.utilityService.isNumericNull(data1.divisionCoordinatorUno);
      objDivision.divisionApproverUno = this.utilityService.isNumericNull(data1.divisionApproverUno);
      objDivision.userUno = this.login_UserID;
      objDivision.tenantUno = this.tenantUno;
      
      this.restApi.addEditDivision(objDivision)
        .subscribe(data => {
          
          if (data != null && data != undefined && data != '') {
          //  Swal.fire('Error', 'Something went wrong!', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong!');
          }
          else {
            this.toaster.show('success', 'Success', 'Division saved.');
            //Swal.fire({
            //  type: 'success',
            //  title: 'Division saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.modalRef.hide();
            this.loadDivision();
          }


          this.spinner.hide();
        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();

        });
      return true;
    }
  }

  DeleteDivision(data1: any) {

    let objDivision = new division();
    objDivision.actionType = this.pageAction;
    objDivision.divisionUno = data1.divisionUno;
    objDivision.userUno = this.login_UserID;
    objDivision.tenantUno = 1;
    
    this.restApi.deleteDivision(objDivision)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          this.toaster.show('success', 'Success', 'Division data has been deleted.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Division data has been deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          
          this.loadDivision();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  DuplicateNameCheck(divisionCode: string, divisionUno:number) {
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {
        //  if (roles.some(role => role.includes(extLink.role))) {
        //    extLink.visible = true;
        //  }
        if (grdData.divisionCode.toLocaleLowerCase() == divisionCode.toLocaleLowerCase() && divisionUno != grdData.divisionUno) {
          rtnValue = true;
        }
      });

      return rtnValue;
    }
  }

  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }
   

  get divisionNameEn(): AbstractControl { return this.divisionForm.get('divisionNameEn'); }

  get divisionNameAr(): AbstractControl { return this.divisionForm.get('divisionNameAr'); }

  get divisionCode(): AbstractControl { return this.divisionForm.get('divisionCode'); }


  createTargetFormGroup(data1: any) {

    this.kpiTargetForm = this.formTargetBuilder.group({
      kpiUno: '',
      yearsArray: this.formTargetBuilder.array([])
    });
  }
  createyearItem(objkpitarget: kpitarget): FormGroup {
    
    return this.formTargetBuilder.group({
      kpiUno: objkpitarget.kpiUno,
      kpiYear: objkpitarget.kpiYear,
      kpiYear_Text: objkpitarget.kpiYear_Text,
      frequency: objkpitarget.frequency,
      kpitarget1: objkpitarget.kpitarget1,
      kpitarget2: objkpitarget.kpitarget2,
      kpitarget3: objkpitarget.kpitarget3,
      kpitarget4: objkpitarget.kpitarget4,
      kpitarget5: objkpitarget.kpitarget5,
      kpitarget6: objkpitarget.kpitarget6,
      kpitarget7: objkpitarget.kpitarget7,
      kpitarget8: objkpitarget.kpitarget8,
      kpitarget9: objkpitarget.kpitarget9,
      kpitarget10: objkpitarget.kpitarget10,
      kpitarget11: objkpitarget.kpitarget11,
      kpitarget12: objkpitarget.kpitarget12,
      kpitarget13: objkpitarget.kpitarget13
    });
  }
  addTargetItem(kpiuno, Frequency): void {
    this.yearsArray = this.kpiTargetForm.get('yearsArray') as FormArray;
    this.spinner.show();
    let inpValue = new kpitarget();
    inpValue.languageUno = 1033;
    inpValue.kpiUno = kpiuno;
    inpValue.kpiYear = this.defaultyear;
    inpValue.frequency = Frequency;
    inpValue.itemUno = 1;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    
    this.restSLAKPIApi.getKpiTargets(inpValue)
      .subscribe(kpidata => {
        let objkpidata: any = kpidata;
        if (objkpidata != null && objkpidata.length > 0)
          for (var i = 0; i < 7; i++) {
            
            this.yearsArray.push(this.createyearItem(kpidata[i]));
          }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });


  }


  AddEditKPITarget(data1: any) {
    if (this.kpiTargetForm == null || this.kpiTargetForm.invalid) {
      // Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong');
      return false;
    }

    
    let objKPITarget = new kpitarget();

    objKPITarget.listkpiTarget = data1.yearsArray;
    objKPITarget.userUno = this.login_UserID;
    objKPITarget.kpiYear = this.defaultyear;
    objKPITarget.kpiUno = this.selected_kpiUno;
    objKPITarget.condition = 1;//(this.pageAction == "add") ? 0 : 1;
    objKPITarget.tenantUno = this.tenantUno;
    objKPITarget.foreCastType = 1;
    
    this.restSLAKPIApi.addKpiTarget(objKPITarget)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'Division Target Saved.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Target Saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadDivision();
        }

        this.modalRef.hide();
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

    return true;

  }

  saveTarget() {
    this.submitClicked = true;
    if (this.kpiTargetForm.valid) {
      this.AddEditKPITarget(this.kpiTargetForm.value);
    }
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.divisionNameEn && a.divisionNameEn.toLowerCase().includes(this.searchText.toLowerCase())        
        || (a.approverName && a.approverName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.coordinatorName && a.coordinatorName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.divisionAdminName && a.divisionAdminName.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }
}
